import { Route, Routes, useLocation } from 'react-router-dom';
import Header from '../components/header';
import { Suspense } from 'react';
import LoadingIndicator from '../components/loadingIndicator';
import UserMapping from '../pages/admin/userMapping';
import CommonCode from '../pages/admin/commonCode';
import DefaultLedger from '../pages/admin/defaultLedger';
import StockMaster from '../pages/admin/stockMaster';
import CompanyMaster from '../pages/admin/companyMaster';
import Home from '../pages';
import UserProfilePage from '../pages/user/profile';
import BatchHistoryPage from '../pages/batchHistory';
import BatchDetail from '../pages/batch';
import RouteGuard from './routeGuard';
import NotAuthorized from './unauthorized';
import Verify from '../pages/verify';
import TallyUploadPage from '../pages/tallyUpload';
import NotFound from '../pages/NotFound';
import TallyCompanyImport from '../pages/admin/tallyCompanyImport';
import ManageTenants from '../pages/super-admin/manageTenants';
import NewTenantPage from '../pages/super-admin/new-tenant';
import UsageReport from '../pages/super-admin/usage-report';

const AdminRoutes = () => (
  <RouteGuard allowedRoles={['Admin']}>
    <Routes>
      <Route path="commonCode" element={<CommonCode />} />
      <Route path="defaultLedger" element={<DefaultLedger />} />
      <Route path="stockMaster" element={<StockMaster />} />
      <Route path="userMapping" element={<UserMapping />} />
      <Route path="companyMaster" element={<CompanyMaster />} />
      <Route path="tally-company-import" element={<TallyCompanyImport />} />
    </Routes>
  </RouteGuard>
);

const SuperAdminRoutes = () => (
  <RouteGuard allowedRoles={['SuperAdmin']}>
    <Routes>
      <Route path="manageTenants" element={<ManageTenants />} />
      <Route path="new-tenant" element={<NewTenantPage />} />
      <Route path="usage-report" element={<UsageReport />} />
    </Routes>
  </RouteGuard>
);

const LayoutContent = () => {
  return (
    <div className="flex flex-row">
      <div className="w-1/6 bg-gray-50 h-full"></div>
      <div className="w-4/5">
        <Suspense fallback={<LoadingIndicator />}>
          <Routes>
            <Route path="/verify" element={<Verify />} />
            <Route path="admin/*" element={<AdminRoutes />} />
            <Route path="super-admin/*" element={<SuperAdminRoutes />} />
            <Route path="" element={<Home />} />
            <Route path="user/profile" element={<UserProfilePage />} />
            <Route path="batchHistory" element={<BatchHistoryPage />} />
            <Route path="batch/:batchId" element={<BatchDetail />} />
            <Route path="/tallyUpload" element={<TallyUploadPage />} />
            <Route path="/unauthorized" element={<NotAuthorized />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </div>
      <div className="w-1/6 bg-gray-50 h-full"></div>
    </div>
  );
};

const Layout = () => {
  const location = useLocation();

  // Define routes that should show full-screen NotFound

  const validRoutes = [
    '/verify',
    '/admin',
    '/super-admin',
    '/user/profile',
    '/batchHistory',

    '/batch',
    '/tallyUpload',
    '/unauthorized',
    '/',
  ];

  const isValidRoute = validRoutes.some(
    route =>
      location.pathname === route ||
      location.pathname.startsWith(route + '/') ||
      location.pathname.startsWith('/admin/') ||
      location.pathname.startsWith('/super-admin/'),
  );

  // If it's an invalid route, show full-screen NotFound

  if (!isValidRoute && location.pathname !== '/') {
    return <NotFound />;
  }

  return (
    <>
      <Header />
      <LayoutContent />
    </>
  );
};

export default Layout;
